import css from './styles.module.css';

export function Ellipsis() {
  return (
    <span className={css.ellipsis} aria-hidden>
      ...
    </span>
  );
}
